export const SnippetContainerId = 'power-trial-finder'

export const PartnerDomainsToSlugs = {
  'sanofi.withpower.com': 'sanofi',
}
export type SupportedPartnerDomains = keyof typeof PartnerDomainsToSlugs
